import React, { useState, useEffect } from 'react';

export default function OfflineBanner() {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [showSynced, setShowSynced] = useState(false);

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
            setShowSynced(true);
            // Hide the "Synced" message after 3 seconds
            setTimeout(() => setShowSynced(false), 3000);
        };

        const handleOffline = () => {
            setIsOnline(false);
            setShowSynced(false);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (isOnline && !showSynced) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: isOnline ? '#28a745' : '#dc3545',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '30px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            zIndex: 9999,
            fontWeight: 'bold',
            fontSize: '14px',
            transition: 'all 0.3s ease-in-out'
        }}>
            {isOnline ? (
                <>
                    <span style={{ fontSize: '18px' }}>✓</span> Back Online: Data Synced
                </>
            ) : (
                <>
                    <span style={{ fontSize: '18px' }}>⚠️</span> Offline Mode: Changes are saved locally
                </>
            )}
        </div>
    );
}
